import React, { useEffect, useState } from 'react'
import moment from 'moment'
import { useWebSocket } from '../../../context/WebSocketContext'
import Loader from '../../../components/Loader'
import DammyImage from '@/assets/dummy-profile-image.svg'
import { styled, alpha } from '@mui/material/styles'
import SearchIcon from '@mui/icons-material/Search'
import InputBase from '@mui/material/InputBase'
import DataUnavailable from '@/components/DataUnavailable'
import { useLocation } from 'react-router-dom'

type Props = {
  onClick: (groupInfo: GroupProps) => void
}

export type GroupProps = {
  _id: string
  profileIds: profileType[]
  groupName: string
  groupType: string
  updatedAt: string
}
export type profileType = {
  countryCode: string
  createdAt: string
  firstName: string
  idBack: string
  idBackOriginalName: string
  idBackkey: string
  idFront: string
  idFrontKey: string
  idFrontOriginalName: string
  lastName: string
  phone: string
  profilePic: string
  profilePicKey: string
  profilePicOriginalName: string
  userId: {
    _id?: string
    email: string
    role: string
  }
}

type ChatListData = GroupProps[]

const GroupList: React.FC<Props> = ({ onClick }) => {
  const { socket } = useWebSocket()
  const [isLoading, setIsLoading] = useState(false)
  const [chatListData, setChatListData] = useState<GroupProps[]>([])
  const [searchTerm, setSearchTerm] = useState('')
  const location = useLocation()

  const Search = styled('div')(({ theme }) => ({
    display: 'flex',
    position: 'relative',
    borderRadius: theme.shape.borderRadius,
    backgroundColor: alpha(theme.palette.common.white, 0.15),
    '&:hover': {
      backgroundColor: alpha(theme.palette.common.white, 0.25),
    },
    marginLeft: 0,
    width: '50%',
    [theme.breakpoints.up('sm')]: {
      marginLeft: theme.spacing(1),
      width: 'auto',
    },
    [theme.breakpoints.down('md')]: {
      width: '100%',
    },
  }))

  const SearchIconWrapper = styled('div')(({ theme }) => ({
    padding: theme.spacing(0, 2),
    height: '100%',
    position: 'absolute',
    pointerEvents: 'none',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  }))

  const StyledInputBase = styled(InputBase)(({ theme }) => ({
    color: 'inherit',
    width: '100%',
    '& .MuiInputBase-input': {
      padding: theme.spacing(1, 1, 1, 0),
      paddingLeft: `calc(1em + ${theme.spacing(4)})`,
      transition: theme.transitions.create('width'),
      [theme.breakpoints.up('sm')]: {
        width: '23ch',
      },
      [theme.breakpoints.down('sm')]: {
        width: '100%',
      },
    },
  }))

  useEffect(() => {
    console.log('iscalled', socket)
    if (!socket) return

    setIsLoading(true)
    socket.emit('get-chat-list')

    const handleChatList = (data: ChatListData) => {
      setChatListData(data)
      setIsLoading(false)
    }

    socket.on('chat-list', handleChatList)

    return () => {
      socket.off('chat-list', handleChatList)
    }
  }, [socket, location.search])

  useEffect(() => {
    if (!socket) return

    const handleGroupCreated = (data: GroupProps) => {
      setChatListData((prevChatListData) => [data, ...prevChatListData])
    }

    socket.on('group-created', handleGroupCreated)

    return () => {
      socket.off('group-created', handleGroupCreated)
    }
  }, [socket])

  const filteredChatListData = chatListData.filter((group) => {
    const normalizedSearchTerm = searchTerm
      .trim()
      .replace(/\s+/g, '')
      .toLowerCase()
    const groupMatches = group.groupName
      .toLowerCase()
      .includes(normalizedSearchTerm)
    const userMatches = group.profileIds.some((profile) => {
      const fullName = `${profile.firstName.trim()} ${profile.lastName.trim()}`
        .replace(/\s+/g, '')
        .toLowerCase()
      return fullName.includes(normalizedSearchTerm)
    })
    return groupMatches || userMatches
  })

  if (isLoading) {
    return <Loader />
  }

  console.log(filteredChatListData, 'group')

  return (
    <>
      <div
        style={{
          display: 'flex',
          justifyContent: 'end',
          marginRight: '20px',
          marginBottom: '20px',
        }}
      >
        <div></div>
        <Search>
          <SearchIconWrapper>
            <SearchIcon />
          </SearchIconWrapper>
          <StyledInputBase
            placeholder="Search…"
            inputProps={{ 'aria-label': 'search' }}
            value={searchTerm}
            onChange={(e) => setSearchTerm(e.target.value)}
            autoFocus
          />
        </Search>
      </div>
      <div className="flex flex-col gap-6">
        {filteredChatListData && filteredChatListData?.length > 0 ? (
          filteredChatListData.map((group: GroupProps, index) => {
            return (
              <div
                className="bg-grad before:rounded-[25px] mr-4"
                key={group._id}
              >
                <div
                  onClick={() => onClick(group)}
                  key={index}
                  className="flex justify-between w-full p-[17px] rounded-[25px] cursor-pointer bg-[#FFFFFF1A] backdrop-blur-lg"
                >
                  <div className="flex items-center gap-4">
                    <div className="flex">
                      {group?.profileIds.length > 0 &&
                        group.profileIds
                          ?.slice(0, 4)
                          ?.map((profile: profileType, key) => {
                            return (
                              <img
                                key={profile.idFrontKey}
                                className={`z-index-${(4 - key) * 10} ${
                                  key > 0 ? '-ml-5 sm:-ml-8' : ''
                                } w-[44px] h-[44px] sm:w-[66px] sm:h-[66px] object-cover rounded-full border-[3px] border-[#ffffff]`}
                                src={
                                  profile?.profilePic
                                    ? profile?.profilePic
                                    : DammyImage
                                }
                                alt={profile.firstName}
                              />
                            )
                          })}
                    </div>
                    <div className="flex flex-col items-start">
                      <p className="text-base sm:text-xl capitalize">
                        {group.groupName}
                      </p>
                      <p className="text-base sm:text-xl">Group</p>
                    </div>
                  </div>
                  <div className="text-xs flex flex-col justify-between items-end">
                    <p className="text-[#959595] font-normal">
                      {moment(group.updatedAt).format('h:mm a')}
                    </p>
                    <p className="text-[#959595] font-normal">
                      {moment(group.updatedAt).fromNow()}
                    </p>
                  </div>
                </div>
              </div>
            )
          })
        ) : (
          <DataUnavailable description="No record found" />
        )}
      </div>
    </>
  )
}
export default GroupList
